import { App } from '@/app/components/App/App'
import { createChatStore } from '@/app/state/chat'
import { createDailyStore } from '@/app/state/daily'
import { createMatrixStore } from '@/app/state/matrix'
import { createNatalStore } from '@/app/state/natal'
import { createSessionStore, getReadySessionState } from '@/app/state/session'
import { api } from '@/app/utils/api'
import { getClientAppData } from '@/app/utils/app-data'
import { metrikaGoal } from '@/app/utils/metrika'
import { hydrate } from 'preact'
import './styles/index.scss'

const appData = getClientAppData()

const sessionStore = createSessionStore()
const chatStore = createChatStore(sessionStore)
const matrixStore = createMatrixStore(sessionStore)
const natalStore = createNatalStore(sessionStore)
const dailyStore = createDailyStore()

api.interceptors.response.use(
  res => res,
  error => {
    if (error.response?.status === 401) {
      sessionStore.getState().clean()
      return
    }
    return Promise.reject(error)
  },
)

if (appData.session !== undefined) {
  sessionStore.setState(getReadySessionState(appData.session))
}

hydrate(
  <App
    chatStore={chatStore}
    dailyStore={dailyStore}
    matrixStore={matrixStore}
    natalStore={natalStore}
    sessionStore={sessionStore}
    appData={appData}
  />,
  document.getElementById('root')!,
)

try {
  const isPwaMode = window.matchMedia('(display-mode: standalone)').matches
    // iOS Safari
    || (window.navigator as any)?.standalone === true

  if (isPwaMode) {
    metrikaGoal('pwa_session')
  }

  window.addEventListener('appinstalled', () => {
    metrikaGoal('pwa_installed')
  })
}
catch (e) {
  console.error(e)
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').catch(console.error)
}
